var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.797,
    height: 13.174,
    viewBox: "0 0 19.797 13.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(0 0)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M12.113,18.926A4.113,4.113,0,1,0,8,14.813,4.072,4.072,0,0,0,12.113,18.926Zm0-6.587a2.474,2.474,0,1,1-2.474,2.474A2.442,2.442,0,0,1,12.113,12.339Z",
    transform: "translate(-5.518 -10.7)",
    fill: "#7a6b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M6.57,40A8.933,8.933,0,0,0,.23,42.721a.769.769,0,0,0,0,1.144.794.794,0,0,0,1.144,0,7.5,7.5,0,0,1,5.2-2.227,7.674,7.674,0,0,1,5.2,2.227.9.9,0,0,0,.588.247.845.845,0,0,0,.588-.247.769.769,0,0,0,0-1.144A9.169,9.169,0,0,0,6.57,40Z",
    transform: "translate(0.025 -30.939)",
    fill: "#7a6b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M42.474,26.248A2.474,2.474,0,1,0,40,23.774,2.442,2.442,0,0,0,42.474,26.248Zm0-3.278a.835.835,0,1,1-.835.835A.779.779,0,0,1,42.474,22.97Z",
    transform: "translate(-27.622 -18.022)",
    fill: "#7a6b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M47.228,41.942A6.924,6.924,0,0,0,40.7,40.3a.814.814,0,0,0,.4,1.577,5.326,5.326,0,0,1,5.041,1.237.792.792,0,0,0,.588.247.845.845,0,0,0,.588-.247A.971.971,0,0,0,47.228,41.942Z",
    transform: "translate(-27.675 -30.995)",
    fill: "#7a6b88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPatient);
export default __webpack_public_path__ + "static/media/TotalPatient.ffae27702229e3b00e8df4da44d054b9.svg";
export { ForwardRef as ReactComponent };